import PrivateView from '@/app/private/private.view.vue';
import { ToolsRoutes } from '@/tools/tools.router';
import { buildSubjectRoutes } from '@/app/private/subjects/views/build-subject/build-subject.router';
import { bookstoreRoutes } from './bookstore/bookstore.router';
import { myContentRoutes } from './my-content/my-content.router';
import { userRequestsRoutes } from './user-requests/user-requests.router';
import { RolesNotAllowGuard } from '@/auth/guards/role-not-allow.guard';
import { ROLES } from '@/auth/enums/auth.enum';

export const PRIVATE_ROUTES = {
  HOME: {
    NAME: 'private.home',
    PATH: 'home'
  },
  PORTAL: {
    NAME: 'private.portal',
    PATH: 'portal'
  },
  CHANGE_PASSWORD: {
    NAME: 'private.change-password',
    PATH: 'change-password'
  },
  BOOKSTORE: {
    NAME: 'private.bookstore',
    PATH: 'bookstore',
  },
  JOIN_MEETING: {
    NAME: 'private.join-meeting',
    PATH: 'meetings/join-meeting/class/:classId/menu/:id/meeting/:meetingId'
  },
  CUSTOMIZE_MEETINGS: {
    NAME: 'meetings',
    PATH: 'meetings/customize-meetings/class/:id/meeting/:meeting'
  },
  ABOUT_US: {
    NAME: 'private.aboutus',
    PATH: 'about-us',
  },
  INSTITUTION: {
    NAME: 'private.institution',
    PATH: 'institution'
  },
  MY_CONTENT: {
    NAME: 'private.myContent',
    PATH: 'myContent',
  },
  CREATE_COURSE: {
    NAME: 'private.create-course',
    PATH: 'create-course/:id?'
  },
  COURSE: {
    NAME: 'private.course',
    PATH: 'course/:courseId/:mode?'
  },
  /* Deprecated route */
  WAITING_ROOM: {
    NAME: 'private.waiting-room',
    PATH: 'meetings/waiting-room/class/:classId/meeting/:id'
  },
  /* End deprecated route */
  USER_REQUESTS: {
    NAME: 'private.user-requests',
    PATH: 'admin/user-requests'
  },
  SUBJECT_TEMPLATE: {
    NAME: 'private.subject-template',
    PATH: 'subject-template/:templateType/:courseId/:mode?'
  },
  CREATE_COURSE_TEMPLATE: {
    NAME: 'private.cretae-course-template',
    PATH: 'create-course-template/:id?'
  },
  SUBJECT_BUILDER: {
    NAME: 'private.subject-builder',
    PATH: 'subject-builder/:id?'
  },
  BUILD_SUBJECT: {
    NAME: 'private.build-subject',
    PATH: 'build-subject'
  },
  SUBJECT_BUILDER_V2: {
    NAME: 'private.subject-builder-v2',
    PATH: 'subject-builder-v2/:id?'
  },
};

export const PrivateRoutes = { 
  path: '/p',
  name: 'private',
  component: PrivateView,
  children: [
    {
      path: '/',
      redirect: {
        name: PRIVATE_ROUTES.PORTAL.NAME
      }
    },
    ToolsRoutes,
    {
      path: PRIVATE_ROUTES.HOME.PATH,
      component: () => import(/* HomePrivateView */'@/app/public/home/home.vue'),
      name: PRIVATE_ROUTES.HOME.NAME
    },
    {
      path: PRIVATE_ROUTES.PORTAL.PATH,
      component: () => import(/* PortalView */'@/app/private/portal/portal.view.vue'),
      name: PRIVATE_ROUTES.PORTAL.NAME,
      beforeEnter: RolesNotAllowGuard.bind({ rolesNotAllow: [ROLES.EDUAC_AUTHOR], name: 'private.home' }),
    },
    {
      path: PRIVATE_ROUTES.CHANGE_PASSWORD.PATH,
      component: () => import(/* ChangePasswordView */'@/auth/views/reset-password/reset-password.vue'),
      name: PRIVATE_ROUTES.CHANGE_PASSWORD.NAME
    },
    {
      path: PRIVATE_ROUTES.BOOKSTORE.PATH,
      component: () => import(/* BookstoreView */'@/app/private/bookstore/views/bookstore/bookstore.view.vue'),
      name: PRIVATE_ROUTES.BOOKSTORE.NAME,
      children: bookstoreRoutes,
      redirect: {
        name: bookstoreRoutes[0].name
      }
    },
    {
      path: PRIVATE_ROUTES.JOIN_MEETING.PATH,
      component: () => import(/* InternalMeeting */'@/meetings/views/internal-meeting/internal-meeting.view.vue'),
      name: PRIVATE_ROUTES.JOIN_MEETING.NAME,
      beforeEnter: RolesNotAllowGuard.bind({ rolesNotAllow: [ROLES.EDUAC_AUTHOR] }),
    },
    {
      path: PRIVATE_ROUTES.CUSTOMIZE_MEETINGS.PATH,
      component: () => import(/* MeetingView */'@/meetings/views/customize-class-groups/customize-class-groups.vue'),
      name: PRIVATE_ROUTES.CUSTOMIZE_MEETINGS.NAME,
      beforeEnter: RolesNotAllowGuard.bind({ rolesNotAllow: [ROLES.EDUAC_AUTHOR] }),
    },
    {
      path: PRIVATE_ROUTES.ABOUT_US.PATH,
      component: () => import(/* AboutPrivateView */'@/app/public/about-us/about-us.vue'),
      name: PRIVATE_ROUTES.ABOUT_US.NAME
    },
    {
      path: PRIVATE_ROUTES.INSTITUTION.PATH,
      component: () => import(/* InstitutionPrivateView */'@/app/public/institution/institution.view.vue'),
      name: PRIVATE_ROUTES.INSTITUTION.NAME
    },
    { 
      path: PRIVATE_ROUTES.MY_CONTENT.PATH,
      component: () => import(/* MyContentView */'@/app/private/my-content/my-content.vue'),
      name: PRIVATE_ROUTES.MY_CONTENT.NAME,
      children: myContentRoutes
    },
    {
      path: PRIVATE_ROUTES.CREATE_COURSE.PATH,
      component: () => import(/* CreateCourseView */'@/app/private/subjects/views/create-subject/create-subject.view.vue'),
      name: PRIVATE_ROUTES.CREATE_COURSE.NAME,
      beforeEnter: RolesNotAllowGuard.bind({ rolesNotAllow: [ROLES.EDUAC_AUTHOR] }),
    },
    {
      path: PRIVATE_ROUTES.COURSE.PATH,
      component: () => import(/* CourseView */'@/app/private/subjects/views/view-subject/view-subject.view.vue'),
      name: PRIVATE_ROUTES.COURSE.NAME,
      beforeEnter: RolesNotAllowGuard.bind({ rolesNotAllow: [ROLES.EDUAC_AUTHOR] }),
    },
    {
      path: PRIVATE_ROUTES.WAITING_ROOM.PATH,
      component: () => import(/* WaitingPageView */'@/meetings/views/waiting-room/waiting-room.vue'),
      name: PRIVATE_ROUTES.WAITING_ROOM.NAME,
      beforeEnter: RolesNotAllowGuard.bind({ rolesNotAllow: [ROLES.EDUAC_AUTHOR] }),
    },
    { 
      path: PRIVATE_ROUTES.USER_REQUESTS.PATH,
      component: () => import(/* UserRequestsView */'@/app/private/user-requests/user-requests.vue'),
      name: PRIVATE_ROUTES.USER_REQUESTS.NAME,
      children: userRequestsRoutes
    },
    {
      path: PRIVATE_ROUTES.SUBJECT_TEMPLATE.PATH,
      component: () => import(/* CourseTemplateView */'@/app/private/subjects/views/view-subject/view-subject.view.vue'),
      name: PRIVATE_ROUTES.SUBJECT_TEMPLATE.NAME
    },
    {
      path: PRIVATE_ROUTES.CREATE_COURSE_TEMPLATE.PATH,
      component: () => import(/* CreateCourseTemplateView */'@/app/private/course-templates/views/create-course-template/create-course-template.view.vue'),
      name: PRIVATE_ROUTES.CREATE_COURSE_TEMPLATE.NAME
    },
    {
      path: PRIVATE_ROUTES.SUBJECT_BUILDER.PATH,
      component: () => import(/* SubjectBuilderView */'@/app/private/subjects/views/subject-builder/subject-builder.view.vue'),
      name: PRIVATE_ROUTES.SUBJECT_BUILDER.NAME,
    },
    { 
      path: PRIVATE_ROUTES.BUILD_SUBJECT.PATH,
      component: () => import(/* BuildSubjectView */'@/app/private/subjects/views/build-subject/build-subject.view.vue'),
      name: PRIVATE_ROUTES.BUILD_SUBJECT.NAME,
      children: buildSubjectRoutes
    },
    {
      path: PRIVATE_ROUTES.SUBJECT_BUILDER_V2.PATH,
      component: () => import(/* SubjectBuilderView V2 */'@/app/private/subjects/views/subject-builder-v2/subject-builder.view.vue'),
      name: PRIVATE_ROUTES.SUBJECT_BUILDER_V2.NAME,
    },
  ]
}